import React, {useContext, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {AppContext} from "../../context/app/appContext";

export const MyOrgMenu = (props) => {
    const history = useHistory();
    const [subMenuActiveItem, setSubMenuActiveItem] = useState('Org Info');

    let location = useLocation();
    console.log(location.pathname);

    const appContext = useContext(AppContext);

    const handleSubMenuItemClick = (e) => {
        e.preventDefault();
        const name = e.target.innerText;
        setSubMenuActiveItem(name);
        let routeLink = name.trim().toLowerCase().replace(' ', '-').replace('/', '-');
        console.info({routeLink});
        history.push(
            routeLink === 'org-info' ? '/account' : `/account/${routeLink}`);
    };

  return (
      <div className="ui segment nav-container" style={{borderWidth: 0, backgroundColor: 'transparent', width: '90vw'}}>
        <nav style={{borderWidth: 0, color: 'black', fontSize: 14, fontStyle: 'SFProText-Medium', backgroundColor: 'transparent'}}
            className="ui pointing secondary menu">
          <a href="#top" onClick={handleSubMenuItemClick}
             className={`item ${subMenuActiveItem === 'Org Info' ?
                 'active' :
                 ''}`}>Org Info</a>
          <a href="#top" onClick={handleSubMenuItemClick}
             className={`item ${subMenuActiveItem === 'Payment Setup' ?
                 'active' :
                 ''}`}>Payment Setup</a>
          <a href="#top" onClick={handleSubMenuItemClick}
              className={`item ${subMenuActiveItem ===
              'Invoices' ? 'active' : ''}`}>Invoices</a>
          <div className="right item" style={{fontWeight: '900'}}>{appContext.organization.legalEntityName}</div>
        </nav>
      </div>
  );
};
